var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84896 7.94434L7.94431 3.84899L12.0484 7.95305L7.95302 12.0484C6.81816 13.1832 4.98092 13.1832 3.84896 12.0484C2.71701 10.9135 2.71701 9.07629 3.84896 7.94434Z",
    fill: "url(#paint0_radial_5645_17993)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94429 7.95306C9.07915 9.08791 10.9164 9.08791 12.0483 7.95306C13.1803 6.8182 13.1832 4.98096 12.0483 3.849C10.9135 2.71705 9.07624 2.71705 7.94429 3.849C6.81234 4.98096 6.80944 6.82111 7.94429 7.95306Z",
    fill: "#00BFFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0485 7.95294L7.95312 12.0483L12.0572 16.1523L16.1525 12.057C17.2874 10.9221 17.2874 9.0849 16.1525 7.95294C15.0177 6.82099 13.1804 6.82099 12.0485 7.95294Z",
    fill: "url(#paint1_radial_5645_17993)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.057 12.0483C13.1919 13.1832 13.1919 15.0204 12.057 16.1524C10.9222 17.2843 9.08492 17.2872 7.95297 16.1524C6.82102 15.0175 6.82102 13.1803 7.95297 12.0483C9.08782 10.9135 10.9251 10.9135 12.057 12.0483Z",
    fill: "#976CF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5645_17993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.96038 5.83255) rotate(135) scale(8.66379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5645_17993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.9345 14.0678) rotate(-45) scale(8.66379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0ab00c74d81a74376f691e1a9ae84fd.svg";
export { ForwardRef as ReactComponent };